import { useHyperTestProjectName } from 'hooks/HypertestJobDetail/useHyperTestProjectName';
import { LTTooltip, LTButton } from '@lambdatestincprivate/lt-components';
import LTText from 'components/LTComponents/LTText/LTText';
import { Link, useNavigate } from 'react-router-dom';
import { Path } from 'constants/routes';
import './index.css';


function decodeBase64Params(url) {
  const parsedUrl = new URL(url);
  const base64Data = parsedUrl.searchParams.get('details');
  if (!base64Data) return {};

  const jsonString = atob(decodeURIComponent(base64Data));
  return JSON.parse(jsonString);
}

function HeaderTitle() {
  const {
    showProjectName,
    fullProjectName,
    truncatedProjectName,
    exceedsCharLimit,
    projectId,
  } = useHyperTestProjectName();
  const navigate = useNavigate();

  if (!showProjectName) {
    return 'HyperExecute';
  }

  const handleJobNumberClick = () => {

    const urlData = decodeBase64Params(window.location.href);
    const jobIdParam = urlData.jobId || '';
    const taskIdParam = urlData.taskId || '';
    const order = urlData.order || '';
    const link = urlData.link || '';
    const activeTab = urlData.activeTab || '';
    const viewBy = urlData.viewBy || '';

    let path = `/hyperexecute/task?jobId=${jobIdParam}&taskId=${taskIdParam}&logType=scenario&order=${order}&link=${link}`;

    // Add tab parameter if activeTab is present
    if (activeTab) {
      path += `&tab=${activeTab}`;
    }

    // Add viewBy parameter if present
    if (viewBy) {
      path += `&viewBy=${viewBy}`;
    }

    navigate(path);
  };

  const renderJobNumber = () => {
    const urlData = decodeBase64Params(window.location.href);

    if (!urlData.jobNumber || !urlData.jobId) {
      return null;
    }
    return (
      <LTButton
        className="hyp-common-header-title-link-button"
        onClick={handleJobNumberClick}
        label={`Job Number - ${urlData.jobNumber}`}
        variant={LTButton.Variant.INVISIBLE}
      />
    );
  };

  const renderProjectName = (name) => {
    if (projectId) {
      return (
        <Link
          className="hyp-common-header-title-link"
          to={`${Path.PROJECT_DETAILS}?projectId=${projectId}`}
          style={{
            color: '#1f2328',
            textDecoration: 'none',
            cursor: 'pointer',
          }}
        >
          {name}
        </Link>
      );
    }
    return name;
  };

  if (exceedsCharLimit) {
    return (
      <> <LTTooltip
        className="hyp-common-header-title"
        text={`${fullProjectName}`}
      >
        <LTText
          color="#1f2328"
          size={14}
          weight={600}
          lineHeight={20}
          as="span"
        >
          <span className="hyp-common-header-title-text">{`HyperExecute / `}</span>
          {renderProjectName(truncatedProjectName)}

        </LTText>

      </LTTooltip>
        <span className="hyp-common-header-title-text"> /</span>
        {renderJobNumber()}</>
    );
  }

  return (
    <div className='common-header-title-box'>
      <span className="hyp-common-header-title-text">{`HyperExecute / `}</span>
      {renderProjectName(fullProjectName)}
      <span className="hyp-common-header-title-text"> /</span>
      {renderJobNumber()}
    </div>
  );
}

export default HeaderTitle;
